export default "__VITE_ASSET__DsuvnMhr__"